import { toCurrency } from '@/utils';
import { toFormattedDate } from '@/utils/date';
import { formatPaymentMethod } from '@/pages/reporting/paymentMethod';

export const SALARY_REPORT_PER_PAGE_OPTIONS = [25, 50, 100, 250];

export const SALARY_REPORT_FIELD_DEFINITIONS = [
  { key: 'full_name', label: 'Employee Name', sortable: true },
  { key: 'work_email', label: 'Email', sortable: true },
  {
    key: 'salary_completed_at',
    label: 'Salary completed',
    sortable: true,
    formatter: value => (value ? toFormattedDate(value, 'DD/MM/YYYY HH:mm') : '—'),
  },
  {
    key: 'salary_amount',
    label: 'Salary amount',
    sortable: true,
    formatter: value => toCurrency(value || 0),
    tdClass: 'text-right',
    thClass: 'text-right',
  },
  {
    key: 'payment_method',
    label: 'Payment method',
    sortable: false,
    formatter: (value, key, item) => formatPaymentMethod(item),
  },
];

// `days_in_failed` and `bucket` are derived per-row in FailedSalaryReport.vue (see failedSalaryBuckets.js).
export const FAILED_SALARY_REPORT_FIELD_DEFINITIONS = [
  { key: 'employee_name', label: 'Employee Name', sortable: true },
  { key: 'employee_code', label: 'Employee Code', sortable: true },
  {
    key: 'salary_after_deductions',
    label: 'Salary amount',
    sortable: true,
    formatter: value => toCurrency(value || 0),
    tdClass: 'text-right',
    thClass: 'text-right',
  },
  {
    key: 'failed_at',
    label: 'Failed since',
    sortable: true,
    formatter: value => (value ? toFormattedDate(value, 'DD/MM/YYYY') : '—'),
  },
  {
    key: 'days_in_failed',
    label: 'Days failing',
    sortable: true,
    formatter: value => (value == null ? '—' : value),
    tdClass: 'text-right',
    thClass: 'text-right',
  },
  { key: 'bucket', label: 'Status', sortable: true },
  {
    key: 'rejection_reasons',
    label: 'Reason',
    sortable: false,
    formatter: value => {
      const text = Array.isArray(value) ? value.filter(Boolean).join(', ') : value;
      return text || '—';
    },
  },
];
